export default __webpack_public_path__ + "static/media/logo2.ed9d5cb7.png";